<template>
  <transition name="team-formation-selector-fade">
    <div class="team-formation-selector-backdrop">
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription"
      >
        <header
          class="team-formation-selector-header ml-0 row align-items-center justify-content-md-center"
          id="modalTitle"
        >
          <slot name="header">
            <div class="col-2">
              <button class="menu-button p-0" @click="close"><i class="fas fa-chevron-left"></i></button>
            </div>
            <div class="col-8 text-center">
              Choose a formation
            </div>
            <div class="col-2"></div>
          </slot>
        </header>
        <section
          class="team-formation-selector-body row text-center"
          id="modalDescription"
        >
          <slot name="body">
            <div class="col-6 col-md-4 col-lg-3 pb-3 team-formation-selector-formation" v-for="formation in formations" :key="formation.name"
                 @click="$emit('selectedTeamFormation', formation.name)">
              <div class="team-formation-name">{{formation.name}}</div>
              <div class="team-formation-description">{{formation.description}}</div>
              <img class="team-formation-image" :src="formation.imageUrl"/>
            </div>
          </slot>
        </section>
        <footer class="team-formation-selector-footer text-center">
          <slot name="footer">
            <button
              type="button"
              class="btn primary"
              @click="close"
              aria-label="Close modal"
            >
              Cancel
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'TeamPlayerSelector',
  props: {
    formations: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
